import {
  FACETED_SEARCH_RECEIVE,
  FACETED_SEARCH_TOGGLE_VALUE,
  FACETED_SEARCH_TOGGLE_COMPACT,
  PRODUCT_FILTERING_RECEIVE,
} from '../constants';
const defaultState = {
  subNavigation: null,
  sortCriteria: null,
  facetFilters: [],
  products: [],
  visibleDropdownMenu: [],
  navigationTheme: 'filter',
  productsViewCachedId: null,
};

export const facetedSearch = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
    case PRODUCT_FILTERING_RECEIVE:
    case FACETED_SEARCH_RECEIVE:
      //Update payload to use search value from state
      let currentQuery = null;
      state.facetFilters.forEach((f) => {
        if (
          f.id == 'myartno' &&
          f.selectedOptions &&
          f.selectedOptions.length == 1 &&
          currentQuery === null
        )
          currentQuery = f.selectedOptions[0];
      });
      payload.facetFilters.forEach((f) => {
        if (
          f.id == 'myartno' &&
          f.selectedOptions &&
          f.selectedOptions.length == 1 &&
          currentQuery !== null
        )
          f.selectedOptions[0] = currentQuery;
      });
      return {
        ...state,
        ...payload,
      };
    case FACETED_SEARCH_TOGGLE_VALUE:
      return {
        ...state,
        facetFilters: payload.facetFilters,
      };
    case FACETED_SEARCH_TOGGLE_COMPACT: {
      const { visibleDropdownMenu } = payload;
      return {
        ...state,
        visibleDropdownMenu: state.visibleDropdownMenu.includes(
          visibleDropdownMenu
        )
          ? []
          : [visibleDropdownMenu],
      };
    }
    default:
      return state;
  }
};
